module.exports = __webpack_public_path__ + "static/media/WonderUnitSans-500.a1489dca.woff2";